(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    class ProductForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      this.submitButton = this.querySelector('button[type="submit"]');
    }

    connectedCallback() {
      if (this.form) {
        this.form.addEventListener('submit', this.handleSubmit.bind(this));
      }
    }

    async handleSubmit(event) {
      event.preventDefault();

      if (!this.submitButton) return;

      const formData = new FormData(this.form);
      const originalText = this.submitButton.textContent;

      this.submitButton.textContent = 'Adding...';
      this.submitButton.disabled = true;

      try {
        const id = formData.get('id');
        const sellingPlan = formData.get('selling_plan');
        const isSubscription = sellingPlan && String(sellingPlan).trim() !== '';
        const subscriptionGiftId = window.RhealGifts && window.RhealGifts.subscriptionGiftIdFor(id);
        const isGiftItself = !!(window.RhealGifts && window.RhealGifts.isGift(id));

        // Inject the subscription free gift into the same add.js payload as
        // the subscription line so the drawer opens with the gift already
        // present. The reconciler still runs post-add to handle downgrades,
        // quantity drift, stale other-market gift IDs, and the separate
        // cart-total gift.
        let fetchInit;
        if (isSubscription && !isGiftItself) {
          const primary = { id: Number(id), quantity: Number(formData.get('quantity') || 1), selling_plan: Number(sellingPlan) };
          const items = [primary];
          if (subscriptionGiftId) items.push({ id: Number(subscriptionGiftId), quantity: 1 });
          fetchInit = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items })
          };
        } else {
          fetchInit = { method: 'POST', body: formData };
        }

        const response = await fetch('/cart/add.js', fetchInit);

        if (response.ok) {
          this.submitButton.textContent = 'Added!';

          document.dispatchEvent(
            new CustomEvent('cart:updated', {
              bubbles: true,
            })
          );

          setTimeout(() => {
            this.submitButton.textContent = originalText;
            this.submitButton.disabled = false;
          }, 1500);
        } else {
          throw new Error('Failed to add to cart');
        }
      } catch (error) {
        this.submitButton.textContent = 'Error';

        setTimeout(() => {
          this.submitButton.textContent = originalText;
          this.submitButton.disabled = false;
        }, 2000);
      }
    }
  }

  if (!customElements.get('product-form')) {
    customElements.define('product-form', ProductForm);
  }
  } catch(e) { console.error(e); }
})();

})();
